import { Component, Input, OnInit } from '@angular/core';
import moment from 'moment';
import { TeamQueryModel } from 'src/app/shared/models/team/team-query.model';

@Component({
  selector: 'app-upcoming-teams-bar-chart',
  templateUrl: './upcoming-teams-bar-chart.component.html',
  styleUrls: ['./upcoming-teams-bar-chart.component.scss'],
  standalone: false
})
export class UpcomingTeamsBarChartComponent implements OnInit {
  @Input() item: TeamQueryModel;

  acceptedSeatsPercentage = 0;
  teamStartsIn = '';
  constructor() {}

  ngOnInit(): void {
    this.acceptedSeatsPercentage = Math.round(
      (this.item.summary.accepted * 100) / this.item.summary.roster
    );
    this.teamStartsIn = this.getStartDay(this.item.startDate);
  }

  private getStartDay(date: Date) {
    let diff = this.getDifferenceInDays(date);

    if (diff < 1) return 'today';

    if (diff == 1) return 'in 1 day';
    if (diff > 1 && diff < 30) return 'in ' + diff + ' days';

    diff = Math.round(diff / 30);
    if (diff == 1) return 'in 1 month';
    if (diff > 1 && diff < 12) return 'in ' + diff + ' months';

    diff = Math.round(diff / 12);
    if (diff == 1) return 'in 1 year';
    if (diff > 1) return 'in ' + diff + ' years';
  }

  private getDifferenceInDays(date) {
    const startDate = moment.utc(new Date(date), 'YYYY-MM-DD').local();

    const currentDate = moment(new Date());
    return Math.ceil(startDate.diff(currentDate, 'days', true));
  }
}
